import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconSortAscendingAlt';
/** Renders an SVG icon. */
const SvgSortAscendingAlt = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.051 25.43a1.25 1.25 0 0 0 1.898 0l5.457-6.366c.695-.811.119-2.064-.95-2.064H10.545c-1.068 0-1.644 1.253-.95 2.064zM12.174 19h7.652L16 23.463zm-2.58-6.063c-.694.81-.118 2.063.95 2.063h10.913c1.067 0 1.644-1.252.949-2.063L16.949 6.57a1.25 1.25 0 0 0-1.898 0l-5.456 6.366Z"
      />
    </svg>
  );
};
SvgSortAscendingAlt.displayName = displayName;
export default SvgSortAscendingAlt;
